module.exports = __webpack_public_path__ + "static/img/ilustra_frente_outro_doc.352c042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc/ilustra_frente_outro_doc.png
// module id = aZb3
// module chunks = 2